declare global {
  interface Window {
    grecaptcha?: {
      ready: (callback: () => void) => void
      execute: (siteKey: string, options: { action: string }) => Promise<string>
    }
  }
}

let loadPromise: Promise<void> | null = null

function loadScript(siteKey: string): Promise<void> {
  if (loadPromise) return loadPromise
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'))
    document.head.appendChild(script)
  })
  return loadPromise
}

// siteKey is null until credentials are configured — getToken then resolves
// null and callers simply omit the token (the server no-ops the same way).
export function useRecaptcha(siteKey: string | null | undefined) {
  async function getToken(action: string): Promise<string | null> {
    if (!siteKey) return null
    await loadScript(siteKey)
    return new Promise((resolve) => {
      window.grecaptcha!.ready(async () => {
        resolve(await window.grecaptcha!.execute(siteKey, { action }))
      })
    })
  }

  return { getToken }
}
